import { UUID } from "../generic/uuid";
import { WineTypeDto } from "@vini-wine/core-dtos";

export interface WineTypeModel extends UUID {
  // transform
  name: string;
}

export const createWineTypeDtoFromOfferWineTypeModel = (
  wineType: WineTypeModel,
): WineTypeDto => {
  return {
    uuid: wineType.uuid,
    name: wineType.name,
  };
};
